module.exports = __webpack_public_path__ + "img/Medchem5_logo.c8d6a45f.png";